import { render, staticRenderFns } from "./SlideOutPanel.vue?vue&type=template&id=60ba0157&scoped=true&"
import script from "./SlideOutPanel.vue?vue&type=script&lang=js&"
export * from "./SlideOutPanel.vue?vue&type=script&lang=js&"
import style0 from "./SlideOutPanel.vue?vue&type=style&index=0&id=60ba0157&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba0157",
  null
  
)

export default component.exports